export enum SystemUserReportTypeEnum {
  PROJECTION = "PROJECTION",
  AI_PROJECTION = "AI_PROJECTION",
  HISTORICAL_ENROLLMENT = "HISTORICAL_ENROLLMENT",
  HISTORICAL_ENROLLMENT_BY_YEAR = "HISTORICAL_ENROLLMENT_BY_YEAR",
  NEW_HOUSING = "NEW_HOUSING",
  NEW_HOUSING_STUDENT_GENERATION_RATES = "NEW_HOUSING_STUDENT_GENERATION_RATES",
  STUDENTS_GENERATED_FROM_NEW_HOUSING = "STUDENTS_GENERATED_FROM_NEW_HOUSING",
  STUDENTS_GENERATED_BY_NEW_HOUSING_PROJECTS = "STUDENTS_GENERATED_BY_NEW_HOUSING_PROJECTS",
  OPEN_ENROLLMENT = "OPEN_ENROLLMENT",
  AI_OPEN_ENROLLMENT = "AI_OPEN_ENROLLMENT",
  OUT_OF_DISTRICT_ENROLLMENT = "OUT_OF_DISTRICT_ENROLLMENT",
  OUT_OF_DISTRICT_ENROLLMENT_BY_YEAR = "OUT_OF_DISTRICT_ENROLLMENT_BY_YEAR",
  EXECUTIVE_SUMMARY = "EXECUTIVE_SUMMARY",
}
